import { i18n } from '~/app/i18n';

/** Stable deployment region identifier used in APIs and config. */
export const ACTIVE_REGION_CODE = 'ALPHA';

export const ACTIVE_REGION_NAME_I18N_KEY = 'activeRegionName' as const;

export const getActiveRegionLabel = (): string =>
  i18n.t(ACTIVE_REGION_NAME_I18N_KEY, { ns: 'account' });
